import { render } from "./vehicle-services.vue?vue&type=template&id=fe3c8018&scoped=true"
import script from "./vehicle-services.vue?vue&type=script&lang=js"
export * from "./vehicle-services.vue?vue&type=script&lang=js"

import "./vehicle-services.vue?vue&type=style&index=0&id=fe3c8018&scoped=true&lang=scss"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe3c8018"]])

export default __exports__